/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authSsoGoogle } from '../../axios/authSsoGoogle'
import type { AuthSsoGoogleError, AuthSsoGoogleRequest, AuthSsoGoogleResponse } from '../../types/AuthSsoGoogle'

export const authSsoGoogleMutationKey = () => [{ url: '/auth/sso/google' }] as const

export type AuthSsoGoogleMutationKey = ReturnType<typeof authSsoGoogleMutationKey>

export type AuthSsoGoogleVariables = {
	data: AuthSsoGoogleRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::ssoGoogle */
export function useAuthSsoGoogle<TContext = unknown>(
	options?: UseMutationOptions<
		AuthSsoGoogleResponse,
		AxiosError<AuthSsoGoogleError>,
		AuthSsoGoogleVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authSsoGoogleMutationKey(),
		mutationFn: ({ data }: AuthSsoGoogleVariables) => authSsoGoogle(data, config).then(res => res.data),
		...options,
	})
}
